import { createHash } from 'crypto'

export function hashSHA256(data: string | undefined): string | undefined {
  return data ? createHash('sha256').update(data).digest('hex') : undefined
}
